import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import Container from "../../components/container";
import { TextHeader } from "../../components/text";
import { COULMN_DATA } from "./constants/columns";
import { ContainerTable, DivButtonExportFile } from "./style/style";
import { TableData } from "./view/table/data";
import { SecondaryButton } from "../../components/button/secondary";
import { Divider, Spin, Upload } from "antd";
import WrapperComponent from "../../components/hoc/WrapperComponent";
import {
  ButtonUploadFileExcel,
  DivButtonImportDevice,
  HeaderButtonImportDevice,
} from "../manage-device/styled";
import { PrimaryButtonClosed } from "../../components/button/buttonClosed";
import { useFileExcel } from "../upload-model/hook/useFileExcel";
import { UploadChangeParam } from "antd/lib/upload";

const UploadModelScene = () => {
  const [loadingTable, setLoadingTable] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const {
    stateUpload,
    stateUploadError,
    onUploadFileExcel,
    onSaveUploadFileExcel,
    downloadModelsMaster,
    downloadModelsData,
    downloadExampleImportModel,
    fileUpload,
    setFileUpload,
    setStateUpload,
    isLoading,
    isErrorFile,
  } = useFileExcel();

  useEffect(() => {
    if (stateUpload.length < 1 || stateUploadError.length > 0) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [stateUpload, stateUploadError]);

  const props = {
    beforeUpload: () => false,
    onChange: (file: UploadChangeParam) => onUploadFileExcel(file),
    fileList: fileUpload,
  };

  return (
    <Container>
      <Spin spinning={isLoading}>
        <TextHeader text={"อัปโหลดโมเดล"} divider={true} />
        <HeaderButtonImportDevice>
          <DivButtonImportDevice>
            <Upload
              {...props}
              maxCount={1}
              accept=".xlsx, .csv, application/vnd.ms-excel"
            >
              <ButtonUploadFileExcel>เลือกไฟล์อัปโหลด</ButtonUploadFileExcel>
            </Upload>
          </DivButtonImportDevice>
          <PrimaryButtonClosed
            label={"บันทึก"}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ marginTop: "20px" }}
            tabletStyle={{ marginTop: "20px" }}
            isDisabled={isDisabled || isErrorFile}
            // isLoading={loading}
            // forceLoading={confirmLoading}
            onPress={() => {
              onSaveUploadFileExcel(stateUpload);
            }}
          />
        </HeaderButtonImportDevice>
        <Divider />
        <ContainerTable>
          <DivButtonExportFile>
            <SecondaryButton
              label={"เทมเพลตอัปโหลด"}
              style={{ marginLeft: "10px" }}
              mobileStyle={{ marginTop: "20px" }}
              tabletStyle={{ marginTop: "20px" }}
              // isLoading={loading}
              // forceLoading={forceLoading}
              onPress={downloadExampleImportModel}
            />
            <SecondaryButton
              label={"ดาวน์โหลดข้อมูลจริง"}
              style={{ marginLeft: "10px" }}
              mobileStyle={{ marginTop: "20px" }}
              tabletStyle={{ marginTop: "20px" }}
              // isLoading={loading}
              // forceLoading={forceLoading}
              onPress={downloadModelsData}
            />
            <SecondaryButton
              label={"ดาวน์โหลดข้อมูล Power BI"}
              style={{ marginLeft: "10px" }}
              mobileStyle={{ marginTop: "20px" }}
              tabletStyle={{ marginTop: "20px" }}
              // isLoading={loading}
              // forceLoading={forceLoading}
              onPress={downloadModelsMaster}
            />
          </DivButtonExportFile>
          <TableData
            columns={COULMN_DATA()}
            data={stateUpload}
            loading={loadingTable}
          />
        </ContainerTable>
      </Spin>
    </Container>
  );
};

export default WrapperComponent("UploadModelScene")(UploadModelScene);
